import { Breakpoint, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

/**
 * Gives you a loading state while the breakpoint for isMobile is processed
 *
 * @param breakpoint - The max value of the screen to measure isMobile
 * @returns An isLoading state and the actual value of isMobile
 */

export const useResponsive = (breakpoint: Breakpoint | number = 'md') => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down(breakpoint));
	const [isReady, setIsReady] = useState(false);
	useEffect(() => {
		// This runs only on the client side after the initial render pass
		setIsReady(true);
	}, []);
	return { isMobile: isReady ? isMobile : false, isLoading: !isReady };
};
